import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { ApiService } from "services/ApiService";

const TeamInviteAcceptPage: React.FC = () => {
    const { teamId } = useParams();
    const [searchParams] = useSearchParams();
    const email = searchParams.get("email");
    const token = searchParams.get("token");
    const [status, setStatus] = useState<string>("Processing...");
    const navigate = useNavigate();

    useEffect(() => {
        const acceptInvite = async () => {
            if (!teamId || !email || !token) {
                setStatus("Missing parameters.");
                return;
            }
            try {
                const response = await ApiService.acceptTeamInvite(
                    teamId,
                    email as string,
                    token as string
                );

                // If response contains email and token, redirect to login with params
                if (response.success && response.data?.email && response.data?.token) {
                    navigate(`/login?email=${encodeURIComponent(response.data.email)}&token=${encodeURIComponent(response.data.token)}&teamId=${encodeURIComponent(teamId)}`);
                    return;
                }

                if (response.success && response.data === true) {
                    setStatus("Invite accepted! You have joined the team.");
                    navigate(`/userHomePage`);
                }
                else if (response.success && response.data === false) {
                    setStatus("Invite already accepted or invalid.");
                    navigate(`/userHomePage`);
                }
                else {
                    setStatus("Failed to accept invite: " + (response.data || "Unknown error"));
                }
            } catch (error) {
                setStatus("Error accepting invite.");
            }
        };
        acceptInvite();
    }, [teamId, email, token, navigate]);

    return (
        <div className="p-8 text-center">
            <h2 className="text-2xl font-bold mb-4">Team Invite</h2>
            <p>{status}</p>
        </div>
    );
};

export default TeamInviteAcceptPage;